import Vue from 'vue'
import Vuex from 'vuex'

Vue.use( Vuex )

export default new Vuex.Store( {
	state: {
		activeFilter: '',
		subFilter: '',
		productGroepen: [],
		search: '',
		searchLatLng: null,
		startPosition: {},
		microCopy: null,
		dealersMapSettings: null,
		referrerProduct: '',
		referrerProductID: null,
		uniqueBrands: []
	},
	mutations: {
		SET_ACTIVE_FILTER: ( state, filter ) => {
			state.activeFilter = filter
		},
		SET_SUBFILTER: ( state, filter ) => {
			state.subFilter = filter
		},
		SET_PRODUCT_GROEPEN: ( state, filter ) => {
			state.productGroepen = filter
		},
		SET_SEARCH: ( state, search ) => {
			state.search = search
		},
		SET_SEARCH_COORDS: ( state, coords ) => {
			state.searchLatLng = coords
		},
		SET_STARTPOSITION: ( state, startPos ) => {
			state.startPosition = startPos
		},
		SET_MICROCOPY: ( state, microCopy ) => {
			state.microCopy = microCopy
		},
		SET_DEALERS_MAP_SETTINGS: ( state, dealersMapSettings ) => {
			state.dealersMapSettings = dealersMapSettings
		},
		SET_REFERRER_PRODUCT: ( state, referrerProduct ) => {
			state.referrerProduct = referrerProduct
		},
		SET_REFERRER_PRODUCT_ID: ( state, referrerProductID ) => {
			state.referrerProductID = referrerProductID
		},
		SET_UNIQUE_BRANDS: ( state, uniqueBrands ) => {
			state.uniqueBrands = uniqueBrands
		}
	},
	actions: {
		setActiveFilter( { commit }, filter ) {
			commit( 'SET_ACTIVE_FILTER', filter )
		},
		setSubFilter( { commit }, filter ) {
			commit( 'SET_SUBFILTER', filter )
		},
		setProductGroepen( { commit }, filter ) {
			commit( 'SET_PRODUCT_GROEPEN', filter )
		},
		setSearch( { commit }, search ) {
			commit( 'SET_SEARCH', search )
		},
		setSearchCoords( { commit }, coords ) {
			commit( 'SET_SEARCH_COORDS', coords )
		},
		setStartPosition( { commit }, startPos ) {
			commit( 'SET_STARTPOSITION', startPos )
		},
		setMicroCopy( { commit }, microCopy ) {
			commit( 'SET_MICROCOPY', microCopy )
		},
		setDealersMapSettings( { commit }, dealersMapSettings ) {
			commit( 'SET_DEALERS_MAP_SETTINGS', dealersMapSettings )
		},
		setReferrerProduct( { commit }, referrerProduct ) {
			commit( 'SET_REFERRER_PRODUCT', referrerProduct )
		},
		setReferrerProductID( { commit }, referrerProductID ) {
			commit( 'SET_REFERRER_PRODUCT_ID', referrerProductID )
		},
		setUniqueBrands( { commit }, uniqueBrands ) {
			commit( 'SET_UNIQUE_BRANDS', uniqueBrands )
		}
	},
	getters: {
		getActiveFilter( state ) {
			return state.activeFilter
		},
		getSubFilter( state ) {
			return state.subFilter
		},
		getProductGroepen( state ) {
			return state.productGroepen
		},
		getSearch( state ) {
			return state.search
		},
		getSearchLatLng( state ) {
			return state.searchLatLng
		},
		getStartPosition( state ) {
			return state.startPosition
		},
		getMicroCopy( state ) {
			return state.microCopy
		},
		getDealersMapSettings( state ) {
			return state.dealersMapSettings
		},
		getReferrerProduct( state ) {
			return state.referrerProduct
		},
		getReferrerProductID( state ) {
			return state.referrerProductID
		},
		getUniqueBrands( state ) {
			return state.uniqueBrands
		}
	}
} )